export const FLAG_PROJECT_FEATURE_KEY = 'flag-project';

export const FLAG_REASON_ESCALATION_BASE_KEY = `flagProject.reason.escalation`;
export const FLAG_REASON_PRIORITY_BASE_KEY = `flagProject.reason.priority`;
export const FLAG_REASON_SUPPORT_BASE_KEY = `flagProject.reason.support`;

export const FLAG_REASON_PRIORITY_I18N_KEYS = ['a', 'b', 'c'];
export const FLAG_REASON_ESCALATION_I18N_KEYS = ['a', 'b', 'c', 'd'];
export const FLAG_REASON_SUPPORT_I18N_KEYS = ['a', 'b'];

export const FLAG_TYPE_PRIORITY_KEY = 'flagProject.type.priority';
export const FLAG_TYPE_ESCALATION_KEY = 'flagProject.type.escalation';
export const FLAG_TYPE_SUPPORT_KEY = 'flagProject.type.support';
export const FLAG_TYPE_I18N_KEYS = ['priority', 'escalation', 'support'];

export const FLAG_TYPE_I18N_FULL_KEY_MAP = FLAG_TYPE_I18N_KEYS.reduce((p, c) => {
  switch (c) {
    case 'priority':
      p[c] = FLAG_REASON_PRIORITY_I18N_KEYS.map(key => `${FLAG_REASON_PRIORITY_BASE_KEY}.${key}`);
      break;
    case 'escalation':
      p[c] = FLAG_REASON_ESCALATION_I18N_KEYS.map(key => `${FLAG_REASON_ESCALATION_BASE_KEY}.${key}`);
      break;
    case 'support':
      p[c] = FLAG_REASON_SUPPORT_I18N_KEYS.map(key => `${FLAG_REASON_SUPPORT_BASE_KEY}.${key}`);
      break;
  }
  return p;
}, {} as Record<string, string[]>);
